export const BEL_SUPPORT_EMAIL = 'support@byda.com.au';

export const FILE_VALIDATION_FAILED_PREFIX = 'FILE_VALIDATION_FAILED:';

export const FILE_VALIDATION_FAILED_TITLE = 'File validation failed';

export function formatUserFacingErrorCode(errorCode: number | string): string {
  return ` (Error code: ${errorCode})`;
}

function formatDetailSentence(detail?: string): string {
  if (!detail?.trim()) {
    return '';
  }
  const trimmed = detail.trim().replace(/\.$/, '');
  return `${trimmed}. `;
}

export function formatBelFileValidationFailedMessage(
  detail?: string,
  idSuffix = ''
): string {
  return `${FILE_VALIDATION_FAILED_PREFIX}${formatDetailSentence(
    detail
  )}Please try again or contact ${BEL_SUPPORT_EMAIL}.${idSuffix}`;
}

export function formatBelNoValidShapesMessage(idSuffix = ''): string {
  return formatBelFileValidationFailedMessage(
    'No valid shapes were found in your file',
    idSuffix
  );
}

type UploadErrorNotification = {
  title: string;
  subtitle: string;
  kind: 'error' | 'warning';
};

export function parseBelUploadError(
  error: string | null
): UploadErrorNotification | null {
  if (!error) {
    return null;
  }

  if (error.startsWith('TIMEOUT:')) {
    return {
      title: 'Your file is taking longer than expected',
      subtitle: error.slice('TIMEOUT:'.length).trim(),
      kind: 'warning'
    };
  }

  if (error.startsWith(FILE_VALIDATION_FAILED_PREFIX)) {
    return {
      title: FILE_VALIDATION_FAILED_TITLE,
      subtitle: error.slice(FILE_VALIDATION_FAILED_PREFIX.length).trim(),
      kind: 'error'
    };
  }

  if (error.startsWith('File upload failed')) {
    return {
      title: 'Upload failed',
      subtitle: error,
      kind: 'error'
    };
  }

  if (error.startsWith('Could not start file processing')) {
    return {
      title: 'Upload failed',
      subtitle: error,
      kind: 'error'
    };
  }

  return {
    title: '',
    subtitle: error,
    kind: 'error'
  };
}
